if (!customElements.get('collection-list')) {
    // js/sections/CollectionListSection.js
    var import_flickity = __toESM(require_js());
    class CollectionListSection extends HTMLElement {
    constructor() {
        super();
        const collectionListElement = this.querySelector(".collection-list");
        this.flickityInstance = new import_flickity.default(collectionListElement, {
        watchCSS: true,
        prevNextButtons: true,
        draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches,
        pageDots: false,
        resize: false,
        cellAlign: collectionListElement.childElementCount < 6 ? "center" : "left",
        contain: true,
        groupCells: true
        });
        let lastWidth = window.innerWidth;
        window.addEventListener("resize", () => {
        if (window.innerWidth !== lastWidth) {
            this.flickityInstance.resize();
            lastWidth = window.innerWidth;
        }
        });
    }
    onUnload() {
        this.flickityInstance.destroy();
    }
    onBlockSelect(event2) {
        if (this.flickityInstance.isActive) {
        this.flickityInstance.selectCell(parseInt(event2.target.getAttribute("data-collection-index")), null, event2.detail.load);
        }
    }
    };

    customElements.define('collection-list', CollectionListSection);
}